import axiosInstance from '../../../helpers/api';

export const getAllStudentChapters = (body) => {
    return axiosInstance.get('/students/chapters', body);
};

export const getStudentChapters = (body) => {
    return axiosInstance.get('/students/chapters/active', body);
};